import { Component, OnInit, ViewChild ,ViewChildren,QueryList} from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MasterService } from 'src/app/masters/master.service';
import { ToastrService } from 'ngx-toastr';
import { PharmacyService } from '../pharmacy.service';
import * as CommonConstants from '../../../utils/common.constants';
import { AddDepartmentComponent } from 'src/app/masters/add-department/add-department.component';
import { AddAddressComponent } from 'src/app/masters/add-address/add-address.component';
import { AddContactComponent } from 'src/app/masters/add-contact/add-contact.component';
import { LoaderService } from 'src/app/common/loader.service';
import swal from 'sweetalert2';
import {CountryISO } from 'ngx-intl-tel-input';
import { IntlTelNumberComponent } from 'src/app/common/intl-tel-number/intl-tel-number.component';
@Component({
  selector: 'app-add-pharmacy',
  templateUrl: './add-pharmacy.component.html',
  styleUrls: ['./add-pharmacy.component.scss']
})
export class AddPharmacyComponent implements OnInit {

  pharmacyForm: FormGroup;
  organisms: any[];
  categories: any[];
  categoriesType: any[];
  legalForms: any[];
  submitted = false;
  partnerId: number;
  partnerType: number = CommonConstants.PARTNER_PHARMACY_TYPE;
  addPharmacyTitle=true;
  editPharmacyTitle;
  agmntQuality: any[];
  certifications: any[];
  partnerGroup: any[];
  countries:any;
  CountryISO = CountryISO;
  @ViewChild(AddDepartmentComponent, { static: true }) hospDepartment: AddDepartmentComponent;
  @ViewChild(AddAddressComponent, { static: true }) hospAddress: AddAddressComponent;
  @ViewChild(AddContactComponent, { static: true }) hospContact: AddContactComponent;
  @ViewChildren(IntlTelNumberComponent) phoneNos: QueryList<IntlTelNumberComponent>
  constructor(private masterService: MasterService, private formBuilder: FormBuilder, private toasterService: ToastrService
    , private pharmacyService: PharmacyService, private loaderService: LoaderService) { }

  ngOnInit() {
    this.loadMasterData();
    this.getFromGroup();
  }

  loadMasterData() {
    this.masterService.getOrganisms().subscribe(response => {
      if (response && response['result']) {
        this.organisms = response['result'];
      }
    })
    this.masterService.getCategory().subscribe(response => {
      if (response && response['result']) {
        this.categories =response['result'].filter(category => category.partnerType == this.partnerType);
      }
    })
   
    this.masterService.getLegalForm().subscribe(response => {
      if (response && response['result']) {
        this.legalForms = response['result'];
      }
    })
    this.masterService.getCertification().subscribe(response => {
      if (response && response['result']) {
        this.certifications = response['result'];
      }
    })
    this.masterService.getAgmntQualtiy().subscribe(response => {
      if (response && response['result']) {
        this.agmntQuality = response['result'];
      }
    })
    this.masterService.getGroup().subscribe(response => {
      if (response && response['result']) {
        this.partnerGroup = response['result'];
      }
    })
    this.masterService.getCategoryType().subscribe(response => {
      if (response && response['result']) {
        this.categoriesType  =response['result'].filter(type => type.partnerType == this.partnerType);
      }
    })
    this.masterService.getCountry().subscribe(response => {
      if (response && response['result']) {
        this.countries = response['result'];

      }
    })

  }


  get f() { return this.pharmacyForm.controls; }

  /**
    * Declare form group
    *  
    */
  private getFromGroup() {
    this.pharmacyForm = this.formBuilder.group({
      'phamaId': [],
      'compaNuNumberEmployees': new FormControl(),
      'compaVaEmail': ['', Validators.email],
      'compaVaMobilePhone1': new FormControl(),
      'compaVaWorkPhone': new FormControl(),
      'compaVaMobilePhone2': new FormControl(),
      'compaVaNameEn': ['', Validators.required],
      'compaVaWorkFax': new FormControl(),
      'leforId': new FormControl(),
      'orgsmId': ['', Validators.required],
      'pacatId': new FormControl(),
      'pctypId': new FormControl(),
      'pagrpId': new FormControl(),
      'compaVaHomepage': new FormControl(),
      'certiId': new FormControl(),
      'qCertiId': new FormControl(),
      'pharmacistName': new FormControl(),
      'nationalId': new FormControl(),
      'professionalId': new FormControl(),
      'longitude': new FormControl(),
      'latitude': new FormControl(),
      'agmntId': new FormControl(),
      'staRecCode': [true]
    })
  }

  save() {
    this.submitted = true;
    if (this.pharmacyForm.invalid) {
      return;
    }
    this.pharmacyForm.patchValue({ staRecCode: this.f.staRecCode.value ? 'A' : 'I'});
    let saveData = this.pharmacyForm.value;
    this.phoneNos.forEach(phone => {
      saveData[phone.type]=phone.setPhoneNumberfrmInternation();
    })

    this.loaderService.display(true);
    this.pharmacyService.save(saveData).subscribe(response => {
      this.loaderService.display(false);
      if (response && response["code"] == 0) {
        this.pharmacyForm.patchValue({ phamaId: response['result'] });
       // this.toasterService.success(response['message'], 'Success');
       swal.fire("Success", response['message'], 'success');
      } else {
        //this.toasterService.error(response['message'], 'Error');
        swal.fire("Error", response['message'], 'error');
      }
    },
    error => {
      this.loaderService.display(false);
    })
  }
reset(){
  this.pharmacyForm.reset();
}
onChangeOrganism(event){
  if(event && event.cotryId){
    let country  =this.countries.filter(type => type.cotryId == event.cotryId);
    this.phoneNos.forEach(phone => {
      phone.selectedCountry=country[0].cotryCode;
   })
  }else{
    this.phoneNos.forEach(phone => {
      phone.selectedCountry=CountryISO.France;
   })
  }
}

}
